import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Issue (or re-issue) a certificate to a student. `pngBlob` is optional but
// recommended (stored image used by the user dashboard).
const IssueCertificate = async ({ payload }) => {
  const formData = new FormData();
  formData.append("session", payload.session || "");
  formData.append("gender", payload.gender || "");
  formData.append("purchase_id", payload.purchase_id || "");
  formData.append("user_id", payload.user_id || "");
  formData.append("certificate_id", payload.certificate_id || payload.purchase_id || "");
  formData.append("name", payload.name || "");
  formData.append("course", payload.course_url || "");
  formData.append("course_title", payload.course_title || "");
  formData.append("type", payload.type || "training");
  formData.append("template_id", payload.template_id || 0);
  formData.append("svg", payload.svg || "");
  formData.append("start_date", payload.start_date || "");
  formData.append("end_date", payload.end_date || "");
  formData.append("issued_date", payload.issued_date || "");
  if (payload.pngBlob) {
    formData.append("certificate_file", payload.pngBlob, "certificate.png");
  }

  const res = await axios.post(ENDPOINT + "admin-issue-certificate.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default IssueCertificate;
